import React from 'react'
import { IconSearch, IconTimes } from '../../../../../../shared/icon/icon'
import { Tooltip } from '../../../../../../shared/component/floating'
import { SEARCH_FIELD_PROPS } from '../../../../../../shared/component/search-field-props'

// A node area's search box. What people type stays as typed (the matcher
// lower-cases internally). `combobox` carries the results list's ARIA
// (role, aria-expanded, aria-controls, aria-activedescendant). The faint "/"
// says how to get here from anywhere on the page (owner 2026-10-09:
// Cmd/Ctrl+K is kept for a future site-wide search); it shows on desktop
// pointers only, and only while the box is empty.
//
// One control (owner 2026-10-11: the placeholder ran under the "/"): the
// icon, the text, the "/" and the clear button share one border and one
// focus ring (node-search.scss). The "/" has its own slot between the text
// and the clear button, so the text ends where the hint starts and never
// runs under it; once there is text the slot goes and the text has the room.
// On hover the hint says what it is ("Press / to search"); screen readers
// learn the shortcut from the box's aria-keyshortcuts, the hint itself stays
// aria-hidden (owner follow-up 2026-10-11).
export const SearchFilter = ({ value, onChange, placeholder = 'Search', inputRef, onKeyDown, combobox }) => {
  const handleChange = e => onChange && onChange(e.target.value)
  const handlerClear = () => {
    onChange && onChange('')
    if (inputRef && inputRef.current) inputRef.current.focus()
  }
  // A click on the hint's slot lands in the box, as it did when the hint
  // sat over the text.
  const focusBox = e => {
    if (!inputRef || !inputRef.current) return
    e.preventDefault()
    inputRef.current.focus()
  }

  return (
    <div className="input-group flex-nowrap node-search-input">
      <span className="input-group-text node-search-icon">
        <IconSearch />
      </span>
      <input
        ref={inputRef}
        {...SEARCH_FIELD_PROPS}
        name="node-search"
        className="form-control"
        placeholder={placeholder}
        aria-label="Search"
        aria-keyshortcuts="/"
        value={value}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        {...combobox}
      />
      {!value &&
        <span className="input-group-text node-search-key-slot" aria-hidden="true" onMouseDown={focusBox}>
          <Tooltip label="Press / to search" keepCase>
            <kbd className="node-search-key" data-testid="search-key-hint">
              /
            </kbd>
          </Tooltip>
        </span>}
      <button type="button" className="input-group-text node-search-clear edxr-pointer" aria-label="Clear" title="Clear" onClick={handlerClear}>
        <IconTimes />
      </button>
    </div>
  )
}
